import { Component, Input } from "@angular/core";
import { CustomColumnComponent ,SharedModule} from "@bb-vendure/admin-ui/core";

@Component({
  selector: "slug-link",
  imports : [SharedModule],
  templateUrl: "./product-name.component.html",
  styleUrl: "./product-name.component.scss",
  standalone: true,
})
export class ProductNameComponent implements CustomColumnComponent {
  @Input() rowItem: { name: string; id: string };
}
